export class Feature {
  featureID: string;
  name: string;
  description: string | null;
  createdDate: string;
  modifiedDate: string | null;

  constructor(data: any) {
    this.featureID = data.featureID;
    this.name = data.name;
    this.description = data.description;
    this.createdDate = data.createdDate;
    this.modifiedDate = data.modifiedDate;
  }
}